module.exports = __webpack_public_path__ + "static/media/18.112a9d62.jpg";